import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography } from 'antd';
import { ProjectDto } from '@/core';
import { EpicCard } from './EpicCard';
import { sort } from '@/utils';
import classes from './EpicCardsList.module.scss';

type PropsType = {
  projectData: ProjectDto;
};

export const EpicCardsList = ({ projectData }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [editedCardsIds, setEditedCardsIds] = useState<string[]>([]);
  const epicsSortedAlphabetically = [...projectData.epics].sort((a, b) => sort(a.name, b.name));

  const handleClickEdit = (id: string) => setEditedCardsIds((prev) => [...prev, id]);
  const handleStopEditCard = (id: string) =>
    setEditedCardsIds((prev) => prev.filter((editedCardId) => editedCardId !== id));

  return (
    <div className={classes.cardsList}>
      <Row className={classes.cardsListTitle}>
        <Col span={12}>
          <Typography.Text>{t('addEpics.name')}</Typography.Text>
        </Col>
        <Col span={12}>
          <Typography.Text>{t('addEpics.description')}</Typography.Text>
        </Col>
      </Row>
      {epicsSortedAlphabetically.map((epic) => (
        <EpicCard
          key={epic.id}
          onClickMenuEdit={() => handleClickEdit(epic.id)}
          isEdit={editedCardsIds.includes(epic.id)}
          stopEditCard={() => handleStopEditCard(epic.id)}
          projectData={projectData}
          {...epic}
        />
      ))}
    </div>
  );
};
